// extracted by mini-css-extract-plugin
export default {"auto":"table-root-responsive_auto__baXS6"};